import * as React from "react";
import type { SVGProps } from "react";
const SvgCloneDocument = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.333 17.497H4.167c-.921 0-1.667-.745-1.667-1.666V6.664"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.5 13.333v-6.81c0-.441-.176-.865-.488-1.177l-2.357-2.358a1.67 1.67 0 0 0-1.178-.488h-6.81C5.746 2.5 5 3.246 5 4.167v9.166C5 14.254 5.746 15 6.667 15h9.166c.921 0 1.667-.746 1.667-1.667"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.5 6.667h-3.333a.834.834 0 0 1-.834-.834V2.5"
    />
  </svg>
);
export default SvgCloneDocument;
